//@ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
//@ts-ignore
import LKModal, { LKModalContainer } from 'shared/LKModal'
import { colors } from 'shared'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import dateComparer from 'loankeeper-common/helpers/dateComparer'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { DELEGATE_SELECT_MODAL } from '../constants'
import ClientDelegateViewModal, {
  openDelegateViewModal,
} from '../../ClientDetails/Tabs/Relationships/Delegates/ClientDelegateViewModal'

const translate = (key: string): string => mainTranslate('frm_company_delegate_select', key)

const config = {
  gridIdentity: { formName: 'frm_company_delegate_select', objectName: 'dbgrd_delegates' },
  columnConfigs: {
    CDate: { valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    IssueDate: { comparator: dateComparer, valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    ExpireDate: { comparator: dateComparer, valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    Active: { iconComponent: (value: number) => (value !== 0 ? 'ok' : 'cancel') },
  },
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: false,
  enableSorting: false,
  enableTranslate: true,
  enableRowSelection: true,
  syncGridState: true,
  getRowStyle: ({
    node: {
      data: { Active },
    },
  }) => {
    if (Active === 0) {
      return { color: colors.grey }
    }
    return {}
  },
}

@LKModalContainer(DELEGATE_SELECT_MODAL)
@connect(undefined, {
  openDelegateViewModal,
})
class DelegateSelectModal extends React.Component {
  componentWillUnmount() {
    const { onClose } = this.props
    if (!this.isClientChoosen && onClose) {
      onClose()
    }
  }

  select = (data) => {
    this.props.closeModal()

    if (this.props.onSelect) {
      this.props.onSelect(data)
    }
  }

  openDelegate = (data) => {
    this.props.openDelegateViewModal({ ...data, linkedfiles: this.props.linkedfiles })
  }

  getContextMenuItems = ({ node: { data } }) => [
    {
      name: translate('cmd_delegate_view'),
      action: () => this.openDelegate(data),
      icon: 'info',
    },
    {
      name: translate('frm_company_delegate_select'),
      action: () => this.select(data),
      icon: 'hand',
    },
  ]

  onRowDoubleClicked = ({ node: { data } }) => this.select(data)

  handleClose = () => {
    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }

  render() {
    const { modalInstanceName } = this.props
    return (
      <>
        <ClientDelegateViewModal />
        <LKModal
          name={modalInstanceName}
          onClose={this.handleClose}
          heading={translate('frm_company_delegate_select')}
          size="medium"
          footer={<LKModal.Footer sideActions={<LKModal.CancelButton text={translate('cmd_close')} />} />}
        >
          <LKGrid
            {...config}
            instanceName="Order-Delegates"
            rowData={this.props.delegates}
            getContextMenuItems={this.getContextMenuItems}
            onRowDoubleClicked={this.onRowDoubleClicked}
          />
        </LKModal>
      </>
    )
  }
}

export default DelegateSelectModal
